var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProcessed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.4 15.4c.1 0 .4 0 .5-.3l6.9-9.6c.3-.3.1-.7-.1-.9-.3-.3-.7-.1-.9.1l-6.9 9.6c-.3.3-.1.7.1.9s.3.2.4.2M24.6 4.8c-.3-.3-.7-.1-.9.1l-11 14.9-4.3-5.2c-.3-.4-.7-.4-.9-.1-.5.2-.5.6-.2.9l5 5.9c.1.1.4.3.5.3.3 0 .4-.1.4-.3L24.7 5.7c.3-.3.2-.7-.1-.9M3.5 14.6c-.3-.4-.7-.4-.9-.1s-.4.7-.1.9l5 5.9c.1.1.4.3.5.3s.3 0 .4-.1c.4-.3.4-.7.1-.9z"
})));
export default SvgProcessed;